import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { SelectedCustomerService } from '../_shared/services/selected-customer.service';
import { AppService } from '../_shared/services/app.service';

export class OverviewDataSource<T, P> implements DataSource<T> {
    private dataSubject = new BehaviorSubject<T[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);

    private paginator: MatPaginator;

    private params: any;

    public loading$ = this.loadingSubject.asObservable();

    private totalCountSubject = new BehaviorSubject<number>(0);
    public totalCount$ = this.totalCountSubject.asObservable();

    constructor(
        private appService: AppService,
        private selectedCustomerService: SelectedCustomerService,
        private load: (params: P) => Observable<any>
    ) {}

    public hasData() {
        return this.dataSubject.value && this.dataSubject.value.length;
    }

    public resetPaging() {
        if (this.paginator) {
            this.paginator.pageIndex = 0;
        }
    }

    public init(paginator: MatPaginator) {
        this.paginator = paginator;
    }

    public connect(): Observable<T[]> {
        return this.dataSubject.asObservable();
    }

    public disconnect(): void {
        this.dataSubject.complete();
        this.loadingSubject.complete();
    }

    public loadOverviewData({
        parameters,
        pageSize = 25,
    }: {
        parameters?: any;
        pageSize?: number;
    } = {}): Observable<any> {
        if (parameters) {
            this.params = parameters;
        }

        const page = this.paginator ? this.paginator.pageIndex : 0;
        const partnerId = this.selectedCustomerService.customerForPartnerMode$.value?.number;

        const { sortBy = 'createdDate', sortOrder = 'desc', ...restParams } = this.params || {};

        this.loadingSubject.next(true);

        return this.loadData({
            ...restParams,
            page,
            pageSize: this.paginator ? this.paginator.pageSize : pageSize,
            sortBy,
            sortOrder,
            partnerId,
            salesArea: this.appService.getSalesAreaName(),
        }).pipe(
            tap((result) => {
                this.paginator.length = result.totalCount;
                this.totalCountSubject.next(result.totalCount);
                this.dataSubject.next(result ? result.items : []);
            }),
            finalize(() => this.loadingSubject.next(false))
        );
    }

    private loadData(params: P) {
        return this.load(params);
    }
}
